export default "__VITE_ASSET__a7UUlQV1__"